const STEPS = [
  { key: "DRAFT", label: "Draft" },
  { key: "SENT", label: "Sent" },
  { key: "CONFIRMED", label: "Confirmed" },
  { key: "RECEIVING", label: "Receiving" },
  { key: "DONE", label: "Done" },
] as const;

function stepIndex(status: string): number {
  if (status === "CANCELLED") return -1;
  if (status === "DRAFT") return 0;
  if (status === "SENT") return 1;
  if (status === "CONFIRMED") return 2;
  if (status === "PARTIALLY_RECEIVED") return 3;
  if (status === "COMPLETED") return 4;
  return 0;
}

export function StatusTimeline({ status }: { status: string }) {
  const idx = stepIndex(status);
  const cancelled = status === "CANCELLED";

  return (
    <div className="rounded-lg border bg-card p-4">
      <div className="text-sm font-medium mb-3">Status</div>
      {cancelled ? (
        <div className="text-sm text-destructive">This purchase order was cancelled.</div>
      ) : (
        <ol className="flex flex-wrap gap-2">
          {STEPS.map((s, i) => {
            const active = i <= idx;
            return (
              <li
                key={s.key}
                className={`rounded-full px-3 py-1 text-xs font-medium border ${
                  active ? "bg-primary text-primary-foreground border-primary" : "bg-muted text-muted-foreground border-transparent"
                }`}
              >
                {s.label}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
